import { createStyles } from 'hooks'

export const useStyles = createStyles(() => ({
  itemWrapper: {
    whiteSpace: 'break-spaces',
  },
}))
